export const COLOR = {
  DEFAULT: 'rgba(0,0,0,0.56)',
  PRIMARY: '#4caf50',
  SECONDARY: '#ff6c6c',
  DISABLED: 'rgba(0,0,0,0.26)',
};
